export default {
  teamList: [],
  teamsLoaded: false,
  teamSaved: false,
  teamDeleted: false,
  apiError: {},
};
